"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissKeyError = exports.FetchZipFromUrlError = exports.ParseUrlError = exports.DownloadSampleApiLimitError = exports.DownloadSampleNetworkError = exports.UnzipError = exports.TemplateZipFallbackError = exports.TemplateNotFoundError = exports.SampleNotFoundError = exports.CancelDownloading = void 0;
const componentError_1 = require("../error/componentError");
const constant_1 = require("./constant");
class CancelDownloading extends Error {
}
exports.CancelDownloading = CancelDownloading;
class SampleNotFoundError extends componentError_1.BaseComponentInnerError {
    constructor(templateName) {
        super(constant_1.errorSource, "SystemError", "SampleNotFoundError", "error.generator.SampleNotFoundError", [templateName]);
    }
}
exports.SampleNotFoundError = SampleNotFoundError;
class TemplateNotFoundError extends componentError_1.BaseComponentInnerError {
    constructor(templateName) {
        super(constant_1.errorSource, "SystemError", "TemplateNotFoundError", "error.generator.TemplateNotFoundError", [templateName]);
    }
}
exports.TemplateNotFoundError = TemplateNotFoundError;
class TemplateZipFallbackError extends componentError_1.BaseComponentInnerError {
    constructor() {
        super(constant_1.errorSource, "SystemError", "TemplateZipFallbackError", "error.generator.TemplateZipFallbackError");
    }
}
exports.TemplateZipFallbackError = TemplateZipFallbackError;
class UnzipError extends componentError_1.BaseComponentInnerError {
    constructor() {
        super(constant_1.errorSource, "SystemError", "UnzipError", "error.generator.UnzipError", undefined, [
            "plugins.frontend.checkFsPermissionsTip",
        ]);
    }
}
exports.UnzipError = UnzipError;
class DownloadSampleNetworkError extends componentError_1.BaseComponentInnerError {
    constructor(url) {
        super(constant_1.errorSource, "UserError", "DownloadSampleNetworkError", "error.generator.DownloadSampleNetworkError", [url]);
    }
}
exports.DownloadSampleNetworkError = DownloadSampleNetworkError;
class DownloadSampleApiLimitError extends componentError_1.BaseComponentInnerError {
    constructor(url) {
        super(constant_1.errorSource, "UserError", "DownloadSampleApiLimitError", "error.generator.DownloadSampleApiLimitError", [url]);
    }
}
exports.DownloadSampleApiLimitError = DownloadSampleApiLimitError;
class ParseUrlError extends componentError_1.BaseComponentInnerError {
    constructor(url) {
        super(constant_1.errorSource, "SystemError", "ParseUrlError", "error.generator.ParseUrlError", [url]);
    }
}
exports.ParseUrlError = ParseUrlError;
class FetchZipFromUrlError extends componentError_1.BaseComponentInnerError {
    constructor(url, error) {
        super(constant_1.errorSource, "SystemError", "FetchZipFromUrlError", "error.generator.FetchZipFromUrlError", [url], ["plugins.frontend.checkNetworkTip"], undefined, undefined, error);
    }
}
exports.FetchZipFromUrlError = FetchZipFromUrlError;
class MissKeyError extends componentError_1.BaseComponentInnerError {
    constructor(keyName) {
        super(constant_1.errorSource, "SystemError", "MissKeyError", "error.generator.MissKeyError", [keyName]);
    }
}
exports.MissKeyError = MissKeyError;
//# sourceMappingURL=error.js.map